export default "__VITE_ASSET__DX3CjE2l__"